module.exports = __webpack_public_path__ + "img/AndroidStudio.0d41afed.png";